// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aJlg","content":"styles_content__gSud9","tableWrap":"styles_tableWrap__EPvcx"};